<template>
  <div>
    <v-breadcrumbs class="py-3" :items="cumps">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
          <span class="purple--text">{{ item.text }}</span>
        </v-breadcrumbs-item>
      </template>
      <template v-slot:divider>
        <v-icon color="grey darken-1">mdi-arrow-right-bold-outline</v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  props: {
    cumps: {
      type: Array,
    },
  },
};
</script>

<style scoped>
.v-breadcrumbs__item span {
  color: var(--primary-color);
  text-decoration: none;
  letter-spacing: 1px;
}
</style>
